blue.ready('productGrid', '.productGrid:not(.productGrid--ie)', grid => {
	const rotators = [...grid.querySelectorAll('[data-rotate]')]
	if(rotators.length){
		let pos = window.sessionStorage.getItem('productGrid') ? parseInt(window.sessionStorage.getItem('productGrid')) : -1

		pos = pos < rotators.length - 1 ? pos + 1 : 0

		grid.insertAdjacentElement('afterbegin', rotators[pos]) 
		grid.classList.add('is-init')
		window.sessionStorage.setItem('productGrid', pos)	
	}	
})
